import type { SelectPaginatedData } from '@brighterly/lib-core-types/ui/selects/interfaces'

import { useAdminRoutes } from '@composables/routes/admin-route.hook'

import { getAxiosErrorMessage } from '@helpers/axios'

import { useToast } from '@UI/Toast/ToastProvider'

interface TutorsListApiOptions {
  query?: string
  page?: number
  signal?: AbortSignal
  preselected?: number[]
}

export const useTutorsListApi = async (
  opts: TutorsListApiOptions = {},
): Promise<SelectPaginatedData | null> => {
  const { query = '', page = 1, signal, preselected } = opts
  const { $axios } = useNuxtApp()

  const toast = useToast()

  const url = useAdminRoutes('admin.tutors.list')

  if (!url) {
    toast.error('Unexpected error. Invalid request URL.')
    return null
  }

  try {
    const params: Record<string, string | number> = {
      page,
      per_page: 25,
    }
    if (query !== '') params.q = query
    if (preselected !== undefined) {
      preselected.forEach((id, idx) => {
        params[`preselected[${idx}]`] = id
      })
    }

    const { data } = await $axios.get(url, { params, signal })
    const paginatedData: SelectPaginatedData | null = data?.data || null

    if (!data.success || !paginatedData) {
      toast.error('Unexpected error.')
      return null
    }

    return paginatedData
  }
  catch (err: unknown) {
    if ((err as Error)?.name === 'CanceledError') return null
    toast.error(getAxiosErrorMessage(err))
    return null
  }
}
